/*
 * @Descripttion:
 * @version:
 * @Author: bbq
 * @Date: 2020-12-08 14:51:21
 * @LastEditors: bbqin
 * @LastEditTime: 2022-01-04 16:25:08
 */
import { BaseStore, hookFactory } from "@platform/template";
import { isArray, isUndefined, isNullOrVoid, isObject, uuidv4, isFunction } from './utils';
import Form from '@platform/form';
const PID = "root";

class Store extends BaseStore {

    constructor(props) {
        super(props);
        this.name = "treeTableStore";
        this.refresh = this.refresh.bind(this);
        this.uuid = this.store.uuid = uuidv4();
    }

    // 数据源
    store = {
        // 表单组件对象
        formStore: Form.useForm(),
        // 表格数据
        data: [],

        // 对象模式数据
        fullDataObject: {},

        // 列模板
        meta: {},

        // 表格属性
        async: false,

        rowId: 'rowId',

        // 是否子
        isCheckedHasChild: false,

        // 展开项
        expandedKeys: [],

        // 选中项
        checkedKeys: {},
        // 半选
        indeterminateKeys: {},

        currentSelectedRow: null,
        currentRow: null,

        // 弹窗类型
        modalType: null,

        // 折行
        isEllipsis: true,

        // 搜索结果
        searchValue: '',
    };

    // 缓存
    cache = {
        cacheData: [],
        langJson: {},
    };

    /**
     * @description: 复写
     * @param {type}
     * @return:
     */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * @description: 复写
     * @param {type}
     * @return:
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate && this.forceUpdate(callback);
        return res;
    }

    /*-------------缓存-------------*/

    /**
     * @description: 设置缓存
     * @param {type}
     * @return:
     */
    setCache(path, value) {
        if (!path) {
            console.warn("invalid params <path> to setting");
            return;
        }
        if (!isArray(path)) {
            path = [path];
        }
        let current = this.cache;
        let len = path.length;
        path.forEach((item, index) => {
            if (!current[item]) {
                current[item] = {};
            }
            if (index === len - 1) {
                current[item] = value;
            } else {
                current = current[item];
            }
        });
    }

    /**
     * @description: 获取缓存
     * @param {type}
     * @return:
     */
    getCache(paths) {
        if (isUndefined(paths)) {
            console.warn("invalid params <paths> to setting");
            return;
        }
        if (!isArray(paths)) {
            paths = [paths];
        }
        let current = this.cache;
        paths.some(item => {
            if (isUndefined(item) || isNullOrVoid(current)) {
                isUndefined(item) &&
                    console.warn("paths has empty item[%s]", paths);
                return;
            }
            if (!current[item]) {
                current = null;
                return;
            }
            current = current[item];
            return true;
        });
        // console.log(this.cache);
        return current;
    }

    /*-------------私有-------------*/

    /*-------------列-------------*/
    /**
     * @description: 设置所有meta
     * @param {type}
     * @return:
     */
    setMeta(meta, id, shouldForceUpdate = true) {
        let name = this.getStore("name");
        id && this.setStore("name", id || name, false);

        // 我觉得这里应该 考虑page上的meta更新
        this.setStore("meta", meta, shouldForceUpdate);

        // 更新表单的meta
        let formStore = this.getStore('formStore');
        if (formStore && meta[id] && isArray(meta[id].items)) {
            let formColumns = [];

            let createTreeColumn = columns => {
                columns.map(item => {
                    if (item.itemtype !== 'customer') {
                        // item 内部东西太复杂 直接给会导致一些问题
                        let nItem = JSON.parse(
                            JSON.stringify(item || {}, (key, value) => {
                                if (key == 'render' || key == 'title') {
                                    // title 和 value 是react对象  会导致问题
                                    return undefined;
                                }
                                return value;
                            }),
                        );
                        if (nItem.children) {
                            return createTreeColumn(nItem.children);
                        }
                        delete nItem.render;
                        delete nItem.title;
                        formColumns.push(nItem);
                    }
                });
            };

            createTreeColumn(meta[id].items);
            console.log(formColumns);

            formStore.setMeta({
                [this.uuid]: {
                    status: 'edit',
                    items: formColumns,
                    moduletype: "form",
                    isunfold: false,
                },
            }, this.uuid);
        }
    }

    /**
     * @description: 获取所有meta
     * @param {type}
     * @return:
     */
    getMeta = () => {
        let meta = this.getStore("meta");
        return meta;
    };

    /**
     * @description: 是否包含当前meta
     * @param {type}
     * @return:
     */
    _hasMeta(id) {
        let meta = this.getStore("meta") || {};
        if (!id || !isObject(meta[id]) || !meta[id].items) {
            console.warn('not find meta');
            return [];
        }
        return meta[id].items;
    }

    /**
     * @description: 获取id所在视图的meta
     * @param {type}
     * @return:
     */
    getViewMeta(id) {
        let viewMeta = this._hasMeta(id);
        return viewMeta;
    }

    /**
     * @description: 设置数据
     * @param {type}
     * @return:
     */
    setData({ data = [], shouldForceUpdate = true, callback }) {
        let res = isArray(data) ? data : this.getData();
        // console.log(res);
        // 格式化data
        this.setStore(["data"], res, shouldForceUpdate, callback);
    }

    /**
     * regexp 可以是方法 也可以是参数
     * @description: 获取数据
     * @param {type}
     * @return:
     */
    // @infoLog
    getData(regexp = []) {
        let data = this.getStore("data");
        // console.log(data);
        // 添加规则什么的  比如删除 

        data = data.filter(item => {
            return !regexp.includes(item.status);
        });
        return data || [];
    }

    // 刷新整个绑定对象
    refresh(callback) {
        this.forceUpdate && this.forceUpdate(callback);
    }

    /*
    *   根据isleaf 添加children
    * */
    addChildren(data) {
        data.forEach(item => {
            if (item.hasOwnProperty("isleaf") && !item.isleaf) {
                item.children = item.children || [];
            }
        });
    }

    /*
    *   添加rowId;
    *   field: rowId字段
    * */
    addRowId(data, field, expandedKeys) {
        if (!Array.isArray(data)) {
            console.warn("addRowId方法，第一个参数应为数组");
            return false;
        }
        if (data.length > 0 && !data[0].values[field]) {
            console.warn(`addRowId方法，没有找到参数${field}`);
            return false;
        }
        data.forEach(item => {
            item.key = item.rowId = item.values[field].value;
            expandedKeys && expandedKeys.push(item.values[field].value);
            if (Array.isArray(item.children)) {
                this.addRowId(item.children, field, expandedKeys);
            }
        });
    }

    /*
    *   同步时，组装树状表所需要的数据结构
    * */
    createNewData(data) {
        if (!Array.isArray(data)) {
            console.warn("createTreeData方法，参数应该为数组");
            return false;
        }
        let group = new Map();
        data.forEach(e => {
            if (!(e.values.pid && e.values.pid.value)) {
                e.values.pid = { value: PID };
            }
            group.get(e.values.pid.value)
                ? group.get(e.values.pid.value).push(e)
                : group.set(e.values.pid.value, [e]);
        });

        function makeDOM(pid) {
            if (group.get(pid)) {
                return group.get(pid).map(e => {
                    e.children = makeDOM(e.values.refpk.value);
                    return e;
                });
            } else {
                return null;
            }
        }
        let newData = makeDOM(PID) || [];
        /* 添加isleaf字段 */
        const addIsLeaf = data => {
            data.forEach(item => {
                if (item.checked) {
                    item.checked = true;
                } else {
                    item.checked = false;
                }
                if (Array.isArray(item.children)) {
                    item.isleaf = false;
                    addIsLeaf(item.children);
                } else {
                    item.isleaf = true;
                }
            });
        };

        addIsLeaf(newData);

        return newData;
    }

    // 更新树表数据
    updateTreeTableStoreData(id, tempdata, rowId) {
        if (rowId === undefined) {
            console.warn("树状表addRowId方法，第三个参数需要传表示行rowid 的字段");
            return false;
        }
        let result = this.createNewData(tempdata)
        this.addRowId(tempdata, rowId);
        this.setData({ data: result, shouldForceUpdate: true });
        this.setStore('rowId', rowId, false);
        // 缓存数据以用于  前端查找 --bbqin
        this.setCache('cacheData', JSON.parse(JSON.stringify(result)));
        this.setStore('searchValue', null, true);
    }

    getHooks = () => {
        // 这样处理的一下 才能报错  方法内部的this 永远指向 实例  否则会指向下面的 {} 对象
        this.getMeta = this.getMeta.bind(this);
        this.setMeta = this.setMeta.bind(this);
        return {
            // 按路径索引 给内部使用
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),
            /*-------------------上面的部分------------------*/
            //模板
            getMeta: this.getMeta.bind(this),
            setMeta: this.setMeta.bind(this),
            getViewMeta: this.getViewMeta.bind(this),

            // 缓存
            getCache: this.getCache.bind(this),
            setCache: this.setCache.bind(this),

            //
            setData: this.setData.bind(this),
            getData: this.getData.bind(this),

            // 刷新
            refresh: this.refresh,

            // 根据定位更新数据
            updateTreeTableStoreData: this.updateTreeTableStoreData.bind(this)
        };
    }
}

export default hookFactory(Store);